import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { localOrSecureStorage } from "@/stores/localOrSecureStorage";

type TokenData = {
  client: string;
  token: string;
  uid: string;
};

type AuthAction = {
  setToken: (tokenData: TokenData) => void;
  clear: () => void;
};

type TokenState = TokenData & AuthAction;

export const useTokenStore = create<TokenState>()(
  persist(
    (set) => ({
      clear: () => set({ client: "", token: "", uid: "" }),
      client: "",
      setToken: (tokenData) => set(tokenData),
      token: "",
      uid: "",
    }),
    {
      name: "token-store",
      partialize: (state): TokenData => ({ client: state.client, token: state.token, uid: state.uid }),
      storage: createJSONStorage(() => localOrSecureStorage),
    },
  ),
);

export const getTokenState = (): TokenState => useTokenStore.getState();
